export default __webpack_public_path__ + "static/media/property_166.ae15bc9b.png";